<div class="container">
    <!-- duration: 'Annual',
    packageDescription:
      'Paid and dealer Telematics supplemental plan for the US.',
    packagePrice: 110,
    packageTitle: 'Remote',
    subsStartDate: '2021-04-13',
    isCurrent: true, -->
  
    <!--CHANGE NOTE:
       change the vehicle name to dynamic for acura and honda, 
       harded becuz we are not using VIN for gdo so can not call myVehicles API-->

    <div>
      <p id="p1" [class]="getHeaderTitleColorClass(subscription)">
        {{ subscription?.packageTitle }} <span *ngIf="!mobile"> for {{channel | titlecase }}Link</span>
      </p>
      <p class="" id="p2" [class]="getColorClass(subscription)">
        {{ subscription?.duration }} Subscription
      </p>
      <p id="p3" *ngIf="subscription?.subsExpiryDate" [class]="getColorClass(subscription)">
        {{ isCurrentPlanCancelled ? 'Cancelled' : isExpired ? 'Expired' : 'Expire' }} at {{ subscription?.subsExpiryDate |
        date : "MM/dd/yyyy" }}
      </p>
      <p id="p3" *ngIf="subscription?.subsStartDate" [class]="getColorClass(subscription)">
        Starts at {{ subscription?.subsStartDate }}
      </p>
    </div>         
    <div>
      <div *ngIf="!subscription?.subsExpiryDate && !subscription?.isEarlyBird">
        <p id="p1" class="font-12 text-sub-color-3 font-weight-400 font-bolder">
          {{ "$" + subscription?.packagePrice }}.00 
          <!-- /{{ subscription?.duration === "5 Year"? "5 yr":"3 yr"}} -->
        </p>
        <p id="p4" class="font-10 grey-color font-weight-400 font-bolder float-right">{{ "$" + packagePrice}} /{{"month"}}</p>
      </div>
      
    </div>

  </div>